import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-38991223"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "flex some-inputs" }
const _hoisted_4 = { class: "flex flex-col m-r-20 input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Наименование бренда", -1))
const _hoisted_6 = { class: "flex flex-col input-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Категории", -1))
const _hoisted_8 = { class: "flex flex-col fl-1 m-t-14" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "use_in_wb_parser",
  class: "m-r-20"
}, "Используется в WB Парсер", -1))
const _hoisted_11 = { class: "flex m-t-20" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "use_in_dl",
  class: "m-r-20"
}, "Используется в DataLens", -1))
const _hoisted_13 = { class: "form-block" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Паттерны", -1))
const _hoisted_15 = { class: "flex flex-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash f-s-12" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  useBrandsStore,
  BrandCategoryCreate,
} from "@/store/dictionaries/brands";
import { useCategoriesStore } from "@/store/catalog_data/categories";
import { CategoryInApi } from "@/store/catalog_data/categories";

import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import InputSwitch from "primevue/inputswitch";

import {
  areBrandFieldsValid,
  createBrandPk,
} from "@/services/dictionaries/brands";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandCreateForm',
  emits: ["setLoading"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;
const route = useRoute();
const router = useRouter();
const store = useBrandsStore();
const categoriesStore = useCategoriesStore();
const catsList = ref([]);

const brand = ref({
  brand_name: "",
  brand_pk: "",
  categories: [] as number[],
  brand_patterns: [{ pattern: "" }],
  is_used_in_wbparser: false,
  is_used_in_datalens: false,
});

const isLoadingData = ref(false);
const isLoadingDataCats = ref(false);
const isInvalidForm = ref(false);
const isBrandSetted = computed(() => {
  return Boolean(route.params.id);
});

const reload = () => {
  isLoadingDataCats.value = true;
  categoriesStore
    .getC1Categories()
    .then((cats) => {
      catsList.value = cats;
    })
    .finally(() => {
      isLoadingDataCats.value = false;
    });
  if (isBrandSetted.value) {
    isLoadingData.value = true;
    const brandPk = route.params.id.toString();
    store
      .getBrand(brandPk)
      .then((brandClone) => {
        if (brandClone) {
          brand.value.brand_name = brandClone.brand_name;
          brand.value.brand_patterns = brandClone.brand_patterns;
          brand.value.brand_pk = brandClone.brand_pk;
          brand.value.categories = brandClone.categories.map(
            (cat: any) => cat.id
          );
          brand.value.is_used_in_wbparser =
            brandClone.is_used_in_wbparser != null
              ? brandClone.is_used_in_wbparser
              : false;
          brand.value.is_used_in_datalens =
            brandClone.is_used_in_datalens != null
              ? brandClone.is_used_in_datalens
              : false;
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

const createBrand = () => {
  const categories: BrandCategoryCreate[] = brand.value.categories.map(
    (category) => ({
      category_id: category,
    })
  );

  const brandToServer = {
    brand_patterns: brand.value.brand_patterns,
    brand: {
      brand_name: brand.value.brand_name,
      brand_pk: brand.value.brand_pk
        ? brand.value.brand_pk
        : createBrandPk(brand.value.brand_name),
      is_used_in_wbparser: brand.value.is_used_in_wbparser,
      is_used_in_datalens: brand.value.is_used_in_datalens,
    },
    categories: categories,
  };

  if (!areBrandFieldsValid(brandToServer)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены.`
    );
    return;
  }

  emit("setLoading", true);
  if (!isBrandSetted.value) {
    performAction(() => store.createBrand(brandToServer));
  } else {
    performAction(() =>
      store.updateBrand(brandToServer, route.params.id.toString())
    );
  }
};

const performAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "brands" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  action()
    .then(handleCampaignSuccess)
    .catch((err: any) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
      if (err.response && err.response.status == 403)
        rootGetters.toast.show("warn", "Ошибка", "Нет доступа.");
    })
    .finally(() => {
      emit("setLoading", false);
    });
};

const addPattern = (idx: number) => {
  brand.value.brand_patterns.splice(idx + 1, 0, { pattern: "" });
};

const deletePattern = (idx: number) => {
  brand.value.brand_patterns.splice(idx, 1);
};

__expose({
  createBrand,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                id: "slug",
                placeholder: "Введите значение",
                modelValue: brand.value.brand_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((brand.value.brand_name) = $event)),
                invalid: isInvalidForm.value && brand.value.brand_name == ''
              }, null, 8, ["modelValue", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(MultiSelect), {
                loading: isLoadingDataCats.value,
                modelValue: brand.value.categories,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((brand.value.categories) = $event)),
                optionValue: "id",
                options: catsList.value,
                optionLabel: "name",
                invalid: isInvalidForm.value && brand.value.categories.length == 0,
                placeholder: "Выберите значение"
              }, null, 8, ["loading", "modelValue", "options", "invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(InputSwitch), {
                modelValue: brand.value.is_used_in_wbparser,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((brand.value.is_used_in_wbparser) = $event)),
                inputId: "use_in_wb_parser"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["is-loading"]),
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_unref(InputSwitch), {
                modelValue: brand.value.is_used_in_datalens,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((brand.value.is_used_in_datalens) = $event)),
                inputId: "use_in_dl"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["is-loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brand.value.brand_patterns, (pattern, idxr) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-col fl-1 m-b-8 role-container",
          key: `pattern-${idxr}`
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(InputText), {
              id: "name",
              class: "fl-1",
              placeholder: "Введите значение",
              modelValue: pattern.pattern,
              "onUpdate:modelValue": ($event: any) => ((pattern.pattern) = $event),
              invalid: isInvalidForm.value && pattern.pattern == ''
            }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"]),
            _createElementVNode("div", {
              class: _normalizeClass(["group-button-container role flex", [idxr != brand.value.brand_patterns.length - 1 ? 'hidden' : '']])
            }, [
              (brand.value.brand_patterns.length > 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "delete-button flex flex-center m-l-8",
                    onClick: ($event: any) => (deletePattern(idxr))
                  }, _hoisted_18, 8, _hoisted_16))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "add-button flex flex-center",
                onClick: ($event: any) => (addPattern(idxr))
              }, _hoisted_21, 8, _hoisted_19)
            ], 2)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})